import { defineMessage } from 'services/localization';

export const messages = {
    label: defineMessage('advanced_plan'),
    tryIt: defineMessage('try_it_for_free_1'),
};
